import React, { useEffect, useState } from 'react';
import './Footer.scss';
import Container from '../../../ui/layouts/Container/Container';
import FooterPlacesList from './components/FooterPlacesList';
import { MobileOnly, TabletAndUpper } from '../../../common/Media/MediaHelpers';
import FooterContactsSection from './components/FooterContactsSection/FooterContactsSection';
import FooterSiteLogo from './components/FooterSiteLogo';
import AppButton from '../../../ui/components/Buttons/AppButton/AppButton';
import { RouteNames } from '../../../../routes';
import { useLocation } from 'react-router-dom';
import classNames from "classnames";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";
import initialApi from '../../../../api/initialApi';

const Footer = () => {
   const location = useLocation();
   const isHomePage = location.pathname === '/';
   const footerClasses = classNames('footer', {'footer-light': !isHomePage})
   const [t] = useTranslation();
   const [partners, setPartners] = useState([]);


   useEffect(() => {
      initialApi.fetchPartner().then((res)=>{
         console.log(res);
         setPartners(res.data || []);
      }).catch((error)=>{

      });
   }, []);

   const partnerView = (
      <div className={'footer__partners'}>
         {partners.map((item, index) => {
            return (
               <a href={item.website_url} target="_blank" className={'footer__partner'} key={index}>
                  <img src={item.logo_url} width={300} />
               </a>
            );
         })}
      </div>
   );

    return (
       <footer className={footerClasses} id={'generalFooter'}>
          <Container>
             <div className={'footer__content'}>
                <div className={'footer__content-block footer__content-block--list'}>
                   <span className={'footer__content-block__text'}>{t('Готелі в Україні')}</span>

                   <div className={'footer__content-block__content'}>
                      <TabletAndUpper>
                         <FooterPlacesList />
                         <a
                            className={'footer__blago'}
                            href="https://blagodeveloper.com/?utm_source=bronui.com&utm_medium=bronui.com&utm_campaign=bronui.com"
                            target="_blank"
                         >
                            blago - нерухомість в Івано-Франківську
                         </a>

                         <div style={{ marginTop: '43px', marginBottom: 20 }}>
                            <FooterSiteLogo />
                            <div>{t('Бронюй тут')}</div>
                         </div>
                         <a
                            className={'footer-rules'}
                            href="https://media.bronui.com/pravyla_ta_umovy.pdf"
                            target="_blank"
                         >
                            Правила та умови
                         </a>
                         <a
                            className={'footer-rules'}
                            href="https://media.bronui.com/ugoda_pro_konfidenciynist.pdf"
                            target="_blank"
                         >
                            Угода про конфіденційність
                         </a>

                         {partnerView}
                      </TabletAndUpper>

                      <MobileOnly>
                         <FooterPlacesList isMobile />
                         <a
                            className={'footer__blago'}
                            href="https://blagodeveloper.com/?utm_source=bronui.com&utm_medium=bronui.com&utm_campaign=bronui.com"
                            target="_blank"
                         >
                            blago - нерухомість в Івано-Франківську
                         </a>
                      </MobileOnly>
                   </div>
                </div>

                <div className={'footer__content-block footer__content-block--contacts'}>
                   <span className={'footer__content-block__text'}>{t('Контакти')}</span>

                   <div className={'footer__content-block__content'}>
                      <div className={'footer__content-block footer__content-block--contacts__contacts-text'}>
                         <FooterContactsSection />
                      </div>

                      <div className={'footer__content-block footer__content-block--contacts__rights-text'}>
                         © {format(new Date(), 'yyyy')} <br />
                         {t(
                            'Всі права захищено. Використання матеріалів цього сайту можливе тільки з посиланням на джерело',
                         )}
                      </div>

                      <div className={'footer__register-link-container'}>
                         <AppButton theme={'outline'} fullWidth to={RouteNames.HOTEL_REGISTRATION}>
                            {t('Реєстрація готелів')}
                         </AppButton>
                      </div>
                      <div className={'footer__extranet-link'}>
                         <AppButton
                            target="_blank"
                            theme={'outline-primary'}
                            fullWidth
                            href={'https://extranet.bronui.com/'}
                         >
                            {t('Вхід в екстранет')}
                         </AppButton>
                      </div>
                      <MobileOnly>
                         <div style={{ marginTop: '20px', marginBottom: 20 }}>
                            <FooterSiteLogo />
                            <div>{t('Бронюй тут')}</div>
                         </div>
                         <a
                            className={'footer-rules'}
                            href="https://media.bronui.com/pravyla_ta_umovy.pdf"
                            target="_blank"
                         >
                            Правила та умови
                         </a>
                         <a
                            className={'footer-rules'}
                            href="https://media.bronui.com/ugoda_pro_konfidenciynist.pdf"
                            target="_blank"
                         >
                            Угода про конфіденційність
                         </a>
                         {partnerView}
                      </MobileOnly>
                   </div>
                </div>
             </div>
          </Container>
       </footer>
    );
};

export default Footer;
